<template>
  <div class="row">
    <div class="col d-flex justify-content-center">
      <z-card
        class="login-wrapper"
        title="COACH SIGN UP"
      >
        <div class="sign-up-text">
          I have an account already,
          <router-link to="/login">
            LOG IN
          </router-link>
        </div>
        <form>
          <div class="row">
            <div class="col-12">
              <z-input-text
                v-model="form.email"
                v-validate.disable="'required'"
                label="EMAIL"
                name="email"
                :error="errors.first('email')"
                @input="resetValidate"
              />
            </div>
            <div class="col-12">
              <z-input-text
                v-model="form.password"
                v-validate.disable="'required'"
                label="PASSWORD"
                name="password"
                type="password"
                :show-eye="!errors.first('password')"
                :error="errors.first('password')"
                @keyup.enter="validate"
                @input="resetValidate"
              />
            </div>
            <div class="col-12 d-flex justify-content-center">
              <z-button
                :loading="loading"
                @click.native="validate"
              >
                Create account
              </z-button>
            </div>
            <div class="col-12 d-flex justify-content-center">
              <span class="or">OR SIGN UP WITH</span>
            </div>
          </div>
          <div class="social-button-list">
            <div class="row">
              <div
                v-for="item in socialList.filter(i => i.enabled)"
                :key="item.value"
                class="col-md-4"
              >
                <z-social-button
                  :image="item.icon"
                  @click.native="socialHandler(item.value)"
                >
                  {{ item.name }}
                </z-social-button>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <ul class="terms-list">
                  <li><a href="https://zeyplay.com/privacy.html">privacy policy</a></li>
                  <li><a href="https://zeyplay.com/terms.html">terms of use</a></li>
                </ul>
              </div>
            </div>
          </div>
        </form>
      </z-card>
      <z-modal
        ref="signupModal"
      >
        <div class="row mt-3">
          <div class="col-12">
            {{ message }}
          </div>
          <div class="col-12 mt-3">
            <z-button @click="close">
              Close
            </z-button>
          </div>
        </div>
      </z-modal>
    </div>
    <vue-recaptcha
      v-if="recaptchaKey"
      ref="recaptcha"
      size="invisible"
      :sitekey="recaptchaKey"
      :load-recaptcha-script="true"
      @verify="submit"
      @expired="onCaptchaExpired"
    />
  </div>
</template>

<script>
import authAPI from '@/api/auth';
import ZCard from '@/components/shared/ZCard.vue';
import ZButton from '@/components/shared/buttons/ZButton.vue';
import ZSocialButton from '@/components/shared/buttons/ZSocialButton.vue';
import ZInputText from '@/components/shared/input/ZInputText.vue';
import ZModal from '@/components/shared/modals/ZModal.vue';
import VueRecaptcha from 'vue-recaptcha';
import { socialList } from '@/config';

export default {
  components: {
    ZCard,
    ZInputText,
    ZButton,
    ZSocialButton,
    ZModal,
    VueRecaptcha,
  },

  data: () => ({
    loading: false,
    form: {
      email: '',
      password: '',
    },
    message: '',
    socialList,
  }),

  computed: {
    recaptchaKey() {
      return this.$store.getters.recaptchaKey;
    },
  },

  async created() {
    await this.$store.dispatch('authInit');
  },

  methods: {
    validate() {
      this.$validator.validateAll().then(async (isValid) => {
        if (isValid) {
          this.$refs.recaptcha.execute();
        }
      });
    },

    resetValidate() {
      this.$validator.reset();
    },

    async submit(recaptchaToken) {
      if (this.loading) return;

      this.loading = true;
      authAPI.signup({ ...this.form, 'g-recaptcha-response': recaptchaToken })
        .then((response) => {
          if (response.data.success) {
            this.message = response.data.data.message;
            this.form = {
              email: '',
              password: '',
            };
            this.$refs.signupModal.open();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    close() {
      this.$refs.signupModal.close();
    },

    socialHandler(socialName) {
      authAPI.socialInit(socialName)
        .then((response) => {
          if (response.data.success) {
            window.location.href = response.data.data.url;
          }
        });
    },

    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
  .login-wrapper {
    margin: 0 auto;
    margin-top: 60px;
    max-width: 630px;
    width: 100%;
    padding: 50px 50px 20px 50px;
  }

  .or {
    display: block;
    color: var(--color-secondary);
    font-size: 14px;
    font-family: var(--font-bold);
    padding: 20px 0;
  }

  .sign-up-text {
    text-transform: uppercase;
    text-align: center;
    font-size: 14px;
    font-family: var(--font-medium);
    margin-bottom: 10px;

    a {
      margin-left: 4px;
      color: var(--color-secondary);
    }
  }

  .terms-list {
    display: flex;
    justify-content: center;
    align-items: center;
    list-style: none;
    padding: 0;
    margin: 0;
    font-size: 14px;

    li {
      margin: 0 10px;
    }

    a {
      color: var(--color-blue-text);
    }
  }

  @media screen and (max-width: 991px) {
    .login-wrapper {
      margin-top: 45px;
      padding: 30px 25px 20px 25px;
    }
  }

  @media screen and (max-width: 767px) {
    .social-button-list {
      margin: 0 auto;
      max-width: 250px;
    }

    .login-wrapper {
      margin: 10px;
      box-sizing: border-box;
      padding: 30px 25px 20px 25px;
    }
  }
</style>
